import React from 'react';
import { useTranslation } from 'react-i18next';

import { theme } from '../../theme';
import { FormStyled } from './Form.styled';

interface RatingFieldProps {
  text?: string;
  number: number;
  selectNumber: number;
  onRateChange: (number: number) => void;
  name: string;
}

export const RatingField: React.FC<RatingFieldProps> = props => {
  const { t } = useTranslation();

  const handleClick = () => {
    props.onRateChange(props.number);
  };

  return (
    <FormStyled.RateWrapper>
      <FormStyled.RateNumber
        name={props.name}
        value={props.number}
        onClick={handleClick}
        readOnly
        style={{
          borderColor:
            props.number === props.selectNumber ? theme.primary : theme.gray,
          cursor: 'pointer',
          outline: 'none'
        }}
      />
      {props.text && (
        <FormStyled.RateText
          style={{
            borderColor:
              props.number === props.selectNumber ? theme.black : theme.white,
            background:
              props.number === props.selectNumber ? theme.black : theme.white,
            color:
              props.number === props.selectNumber ? theme.white : theme.gray
          }}
        >
          {t(props.text)}
        </FormStyled.RateText>
      )}
      {!props.text && <FormStyled.RateText>&nbsp;</FormStyled.RateText>}
    </FormStyled.RateWrapper>
  );
};
